/* =============================================================
   aiwa-product-grid-shared.js
   Idempotent loader — guards prevent double-binding if this asset
   is included by multiple sections on the same page.

   Capabilities:
     1. Digit equalization — wraps digit-runs in <span class="aiwa-digit">
        so the CSS multiplier brings digit ink-height up to letter cap-height
        (Cormorant's lining-nums feature is weak; em-relative span compensates).
     2. Heart toggle — clicks favorites in/out of localStorage.aiwa.favorites
        and dispatches an `aiwa:favorites:change` CustomEvent.
     3. Floating #aiwa-fav-badge — mounted once per page, syncs count
        from localStorage + event, hidden when count = 0.

   Triggered on DOMContentLoaded + `aiwa:collection:rendered` custom event
   + MutationObserver on the document so dynamically-rendered cards
   (AJAX section render, etc.) get re-processed.

   Loaded by: snippets/product-card.liquid (one include, cascades to
   every section that renders the snippet).
   ============================================================= */
(function () {
  if (window.__aiwaProductGridSharedLoaded) return;
  window.__aiwaProductGridSharedLoaded = true;

  var FAV_KEY = 'aiwa.favorites';
  var FAV_EVENT = 'aiwa:favorites:change';

  /* ---------- localStorage helpers ---------- */
  function getFavorites() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); }
    catch (e) { return []; }
  }
  function setFavorites(list) {
    try {
      localStorage.setItem(FAV_KEY, JSON.stringify(list));
      window.dispatchEvent(new CustomEvent(FAV_EVENT, { detail: list }));
    } catch (e) {}
  }
  function toggleFavorite(handle) {
    if (!handle) return false;
    var list = getFavorites();
    var idx = list.indexOf(handle);
    if (idx >= 0) { list.splice(idx, 1); setFavorites(list); return false; }
    list.push(handle); setFavorites(list);
    return true;
  }
  window.aiwaGetFavorites = getFavorites;
  window.aiwaToggleFavorite = toggleFavorite;

  /* ---------- 1. Digit equalization ---------- */
  function equalizeDigits(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var titles = scope.querySelectorAll(
      '.product-grid .aiwa-product-card .aiwa-product-name, ' +
      '.product-grid .aiwa-product-name, ' +
      '.product-grid .card-information__text, ' +
      '.product-grid .card-information__text a, ' +
      '#CollectionAIProductGrid .aiwa-product-name'
    );
    titles.forEach(function (el) {
      if (el.__aiwaDigitsDone) return;
      el.__aiwaDigitsDone = true;
      walkTextNodes(el, function (textNode) {
        var v = textNode.nodeValue;
        if (!/\d/.test(v)) return;
        var frag = document.createDocumentFragment();
        var parts = v.split(/(\d+)/);
        parts.forEach(function (part) {
          if (!part) return;
          if (/^\d+$/.test(part)) {
            var s = document.createElement('span');
            s.className = 'aiwa-digit';
            s.textContent = part;
            frag.appendChild(s);
          } else {
            frag.appendChild(document.createTextNode(part));
          }
        });
        textNode.parentNode.replaceChild(frag, textNode);
      });
    });
  }
  function walkTextNodes(node, fn) {
    if (node.nodeType === 3) { fn(node); return; }
    if (node.nodeType !== 1) return;
    if (node.tagName === 'SCRIPT' || node.tagName === 'STYLE') return;
    var children = Array.from(node.childNodes);
    children.forEach(function (c) { walkTextNodes(c, fn); });
  }

  /* ---------- 2. Heart toggle (event delegation) ---------- */
  function syncHeartState(btn) {
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    var faved = getFavorites().indexOf(handle) >= 0;
    btn.setAttribute('data-favorited', faved ? 'true' : 'false');
    btn.setAttribute('aria-pressed', faved ? 'true' : 'false');
  }
  function syncAllHearts(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var hearts = scope.querySelectorAll('.aiwa-card-heart[data-product-handle]');
    hearts.forEach(syncHeartState);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.aiwa-card-heart');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    toggleFavorite(handle);
    syncHeartState(btn);
  }, true /* capture */);

  /* ---------- 3. Floating favorites badge ---------- */
  function mountFavBadge() {
    if (document.getElementById('aiwa-fav-badge')) return;
    var locale = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2);
    var isAr = locale === 'ar';
    var a = document.createElement('a');
    a.id = 'aiwa-fav-badge';
    a.href = '/pages/favorites';
    a.setAttribute('aria-label', isAr ? 'المفضلة' : 'Favorites');
    a.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>' +
      '</svg>' +
      '<span class="aiwa-fav-badge__count">0</span>';
    document.body.appendChild(a);
    refreshFavBadge();
  }
  function refreshFavBadge() {
    var badge = document.getElementById('aiwa-fav-badge');
    if (!badge) return;
    var count = getFavorites().length;
    var span = badge.querySelector('.aiwa-fav-badge__count');
    if (span) span.textContent = String(count);
    if (count > 0) badge.removeAttribute('hidden');
    else badge.setAttribute('hidden', '');
  }
  window.addEventListener(FAV_EVENT, refreshFavBadge);

  /* =============================================================
     4. ATC AJAX flow — extracted from sections/main-collection-ai.liquid
     so the slider, /pages/favorites, /search, recommendations all
     share an identical popup. Guarded so that if a page ALSO loads
     the inline handler (currently only main-collection-ai.liquid does),
     this binder yields.
     ============================================================= */
  var __atcTimer = null;
  var __toastTimer = null;
  function isAr() {
    return (document.documentElement.getAttribute('lang') || 'en').slice(0, 2) === 'ar';
  }
  function mountAddToCartPopup() {
      if (document.getElementById('aiwa-atc-popup')) return;
      var ar = isAr();
      var i18n = {
        added:       ar ? 'تمت الإضافة إلى السلة'     : 'Added to cart',
        viewCart:    ar ? 'عرض السلة'                : 'View Cart',
        continue_:   ar ? 'متابعة التسوق'             : 'Continue Shopping',
        close:       ar ? 'إغلاق'                    : 'Close',
        unavailable: ar ? 'غير متوفر حاليًا'          : 'Currently unavailable',
        cartHref:    ar ? '/ar/cart'                 : '/cart'
      };

      var pop = document.createElement('div');
      pop.id = 'aiwa-atc-popup';
      pop.setAttribute('role', 'dialog');
      pop.setAttribute('aria-live', 'polite');
      pop.setAttribute('aria-label', i18n.added);
      pop.innerHTML =
        '<button type="button" class="aiwa-atc-popup__close" aria-label="' + i18n.close + '" data-aiwa-atc-close>&times;</button>' +
        '<div class="aiwa-atc-popup__check">' + i18n.added + '</div>' +
        '<div class="aiwa-atc-popup__row">' +
          '<img class="aiwa-atc-popup__img" src="" alt="" data-aiwa-atc-img>' +
          '<div>' +
            '<h3 class="aiwa-atc-popup__title" data-aiwa-atc-title></h3>' +
            '<div class="aiwa-atc-popup__price" data-aiwa-atc-price></div>' +
          '</div>' +
        '</div>' +
        '<div class="aiwa-atc-popup__actions">' +
          '<a href="' + i18n.cartHref + '" class="aiwa-atc-popup__btn aiwa-atc-popup__btn--primary">' + i18n.viewCart + '</a>' +
          '<button type="button" class="aiwa-atc-popup__btn" data-aiwa-atc-close>' + i18n.continue_ + '</button>' +
        '</div>';
      document.body.appendChild(pop);

      var toast = document.createElement('div');
      toast.id = 'aiwa-atc-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.dataset.unavailable = i18n.unavailable;
      document.body.appendChild(toast);
    }

    function openAtcPopup(data) {
      var pop = document.getElementById('aiwa-atc-popup');
      if (!pop) return;
      var img = pop.querySelector('[data-aiwa-atc-img]');
      var title = pop.querySelector('[data-aiwa-atc-title]');
      var price = pop.querySelector('[data-aiwa-atc-price]');
      if (img) img.src = data.image || '';
      if (title) title.textContent = data.title || '';
      if (price) price.innerHTML = data.price || '';
      pop.setAttribute('data-open', 'true');
      if (__atcTimer) clearTimeout(__atcTimer);
      __atcTimer = setTimeout(closeAtcPopup, 5000);
    }
    function closeAtcPopup() {
      var pop = document.getElementById('aiwa-atc-popup');
      if (pop) pop.removeAttribute('data-open');
      if (__atcTimer) { clearTimeout(__atcTimer); __atcTimer = null; }
    }
    function showToast() {
      var t = document.getElementById('aiwa-atc-toast');
      if (!t) return;
      t.textContent = t.dataset.unavailable || (isAr() ? 'غير متوفر حاليًا' : 'Currently unavailable');
      t.setAttribute('data-open', 'true');
      if (__toastTimer) clearTimeout(__toastTimer);
      __toastTimer = setTimeout(function () { t.removeAttribute('data-open'); }, 3000);
    }

  /* capture-phase delegation — must beat the parent <a> default.
     Guarded so we don't double-bind alongside the inline handler in
     main-collection-ai.liquid (it sets window.__aiwaCollectionWired). */
  if (!window.__aiwaAddToCartLoaded && !window.__aiwaCollectionWired) {
    window.__aiwaAddToCartLoaded = true;

    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest && e.target.closest('[data-aiwa-atc-close]');
      if (closeBtn) { e.preventDefault(); closeAtcPopup(); return; }

      var addBtn = e.target.closest && e.target.closest('[data-aiwa-add-to-cart]');
      if (!addBtn) return;
      e.preventDefault();
      e.stopPropagation();
      var card = addBtn.closest('.aiwa-product-card');
      if (!card) return;
      var variantId = card.getAttribute('data-first-variant');
      var isMulti = card.getAttribute('data-has-multiple-variants') === 'true';
      var cardHref = card.getAttribute('href');

      if (isMulti) { window.location.href = cardHref; return; }
      if (!variantId) return;

      addBtn.setAttribute('data-loading', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        addBtn.removeAttribute('data-loading');
        if (!res.ok) { showToast(); return; }
        openAtcPopup({
          title: card.getAttribute('data-product-title') || '',
          image: card.getAttribute('data-product-image') || '',
          price: card.getAttribute('data-product-price') || ''
        });
      })
      .catch(function (err) {
        addBtn.removeAttribute('data-loading');
        console.error('[aiwa-atc shared] add failed', err);
        showToast();
      });
    }, true /* capture */);
  }

  /* ---------- Init + observers ---------- */
  function initAll(root) {
    /* 2026-05-30 Path B — equalizeDigits() retained as a helper but no longer fired.
       The 1.55em multiplier was calibrated for Cormorant Garamond's weak lnum (digits
       at 63% of cap-height). When the rendered font falls back to Tajawal/Assistant on
       Arabic surfaces, those fonts already have full-height lining figures, so the
       multiplier over-amplifies to 155% — exactly the screenshot bug Tarek reported.
       Runtime font.check is unreliable (returns true even when font didn't render),
       so Path B: drop the JS wrap; rely on font-variant-numeric: lining-nums alone. */
    /* equalizeDigits(root); */
    syncAllHearts(root);
    mountFavBadge();
    refreshFavBadge();
    if (window.__aiwaAddToCartLoaded) {
      try { mountAddToCartPopup(); } catch (e) {}
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('aiwa:collection:rendered', function (e) {
    initAll(e.target || document);
  });
  /* MutationObserver — catches AJAX-rendered cards (search, infinite scroll, etc.) */
  if ('MutationObserver' in window) {
    var rafPending = false;
    var mo = new MutationObserver(function () {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () {
        rafPending = false;
        initAll(document);
      });
    });
    try {
      mo.observe(document.body || document.documentElement,
        { childList: true, subtree: true });
    } catch (e) {}
  }
})();
